import * as React from 'react'
import { InspectableImage } from '../photo/InspectableImage'
import classNames from 'classnames'
import type { CommonDeps } from '../base/CommonDeps'

interface Props {
    downloadUrl: string
    allowImageZoom: boolean
    deps: CommonDeps
    slot?: string
    tile?: boolean
}

export function PhotoFileGuide(props: Props) {
    const classes = classNames({
        'AppCore__guide__PhotoFileGuide-img': true,
        'AppCore__guide__PhotoFileGuide-img--tile': props.tile,
    })

    return props.allowImageZoom ? (
        <div className={classes} slot={props.slot}>
            <InspectableImage
                src={props.downloadUrl}
                deps={props.deps}
                fullSizeSrc={props.downloadUrl}
                annotation={null}
                title=""
                tile={props.tile}
            />
        </div>
    ) : (
        <img className={classes} src={props.downloadUrl} slot={props.slot} />
    )
}
